import { Avatar, Skeleton, SxProps } from "@mui/material";
import { useMemo } from "react";
import { TbCancel, TbUser, TbUserStar } from "react-icons/tb";

import { softColors } from "@/constants/colors";
import { capitalizeWords } from "@/helpers/strings";
import useWindowDimensions from "@/hooks/useWindowDimensions";

import ClipBoard from "./ClipBoard";

export function PassengerCardSkeleton({ className }: Pick<PassengerCardProps, "className">) {
    return (
        <>
            <div className={`flex   items-center h-full   hover:underline ${className}`}>
                <Skeleton variant="rounded" width={25} height={25} />
                <Skeleton variant="text" width={130} height={24} />
            </div>
        </>
    );
}
export type PassengerCardProps = {
    name: string | undefined;
    isCustom: boolean;
    cancelled?: boolean;
    className: string;
    avatarVariant?: "circular" | "square" | "rounded";
    avatarSize?: number;
    withoutClipBoard?: boolean;
};
export function PassengerCard({
    name,
    isCustom,
    cancelled = false,
    className,
    avatarVariant,
    avatarSize,
    withoutClipBoard,
}: PassengerCardProps) {
    const { size } = useWindowDimensions();
    const style = useMemo(() => {
        const rawStyle: SxProps = {
            width: avatarSize || 25,
            height: avatarSize || 25,
        };
        if (cancelled) {
            rawStyle.bgcolor = softColors.red.bg;
            rawStyle.color = softColors.red.hover;
        }
        if (isCustom) {
            rawStyle.bgcolor = softColors.indigo.bg;
            rawStyle.color = softColors.indigo.hover;
        }

        return rawStyle;
    }, [isCustom, cancelled, avatarSize]);

    const passengerName = capitalizeWords(name || "");
    return (
        <div className={`flex   items-center h-full   hover:underline ${className}`}>
            {size.md && (
                <Avatar sx={style} className="!ml-1" variant={avatarVariant || "rounded"}>
                    {cancelled ? <TbCancel /> : isCustom ? <TbUserStar size={16} /> : <TbUser size={16} />}
                </Avatar>
            )}
            <div className={`font-semibold  !capitalize break-all ${cancelled ? "text-red-800" : "text-gray-900"}`}>
                {withoutClipBoard ? passengerName : <ClipBoard text={passengerName}>{passengerName}</ClipBoard>}
            </div>
        </div>
    );
}
